<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <div class="docs__top">
          <h1 class="docs__title">
            {{ t('docs.aboutUs.title') }}
          </h1>
        </div>

        <div class="docs__main">
          <div
              v-for="(item, index) in content"
              :key="index"
              class="docs__block"
          >
            <h2 class="docs__subtitle">
              {{ item.title }}
            </h2>
            <p class="docs__text">
              {{ item.text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, tm } = useI18n()

const content = computed(() => tm('docs.aboutUs.content') || [])
</script>

<style lang="scss" scoped>
.docs {
  padding-top: 150px;
  color: $white;

  &__top {
    border-bottom: 1px solid #1e1e1e;

    & h1 {
      width: fit-content;
      padding-bottom: 10px;
      border-bottom: 3px solid #3b3b3b;
      color: #3b3b3b;
      font-size: 24px;
      font-weight: 700;
      line-height: 30px;
    }
  }

  &__main {
    margin-top: 50px;
  }
}

.docs__block {
  &:not(:last-child) {
    margin-bottom: 32px;
  }
}

.docs__subtitle {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #3b3b3b;
}

.docs__text {
  font-size: 14px;
  line-height: 18px;
  color: #3b3b3b;
}


:deep(ul) {
  padding-left: 20px;
}
:deep(p) {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
:deep(li) {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
:deep(a) {
  color: #ff0000;
  font-weight: 500;

  @include hover {
    color: #af0000;
  }
}

@media (max-width: 750px) {
  .docs {
    &__top {
      padding-block: 40px;
    }

    &__title {
      font-size: 42px;
    }
  }

  :deep(p) {
    font-size: 16px;
  }
  :deep(li) {
    font-size: 16px;
  }
}
</style>